import { WorkOrderItemData } from '../index';
import { message } from 'antd';
import { useDisclosure } from '@/hooks';
import { useWorkorderItemPermissions } from '../../WorkOrderItemPartForm/workorderItemPermissions';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import WorkOrderItemSpan from '../WorkOrderItemSpan';
import { quantityFormatter } from '@/utils/number';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import InputDecimalCell from '@/components/_common/InputDecimalCell';
import useWorkOrderItemUpdate from '../WorkOrderItemUtils/useWorkOrderItemUpdate';

interface Props {
  item: WorkOrderItemData;
}

export default function WorkOrderItemQuantity(props: Props) {
  const [isInputEnabled, inputAction] = useDisclosure(false);
  const itemPermissions = useWorkorderItemPermissions();

  const {
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const update = useWorkOrderItemUpdate(props.item);

  const handleUpdateQuantity = async (quantity: number) => {
    if (!itemPermissions.allowSellingBellowCostValue) {
      const subTotal = (quantity || 0) * (props.item?.unitPrice || 0);

      const amount = subTotal - (props.item?.discount || 0) * 100;

      if (amount < (props.item?.unitCost || 0)) {
        message.destroy();
        return message.warn(
          'O preço de venda deve ser maior que o custo unitário',
        );
      }
    }

    try {
      await update.mutateAsync({
        key: 'quantity',
        value: quantity <= 0 ? 1 : quantity,
      });
    } finally {
      inputAction.close();
    }
  };

  if (isInputEnabled) {
    return (
      <InputDecimalCell
        defaultValue={props.item.quantity}
        min={0}
        loading={update.isLoading}
        onConfirmValue={(value) => handleUpdateQuantity(value)}
        onClose={inputAction.close}
      />
    );
  }

  return (
    <WorkOrderItemSpan
      item={props.item}
      onClick={inputAction.open}
      permission={
        (complement?.status !== WorkOrderComplementStatus.Open &&
          !hasPermissions([
            Authorities.MOVIMENTATION_WORKORDER_OPENED_ITEM_CHANGE_QUANTITY,
          ])) ||
        !hasPermissions([
          Authorities.MOVIMENTATION_WORKORDER_ITEM_CHANGE_QUANTITY,
        ])
      }
    >
      {props.item.quantity ? quantityFormatter(props.item.quantity) : 0}
    </WorkOrderItemSpan>
  );
}
